import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e98e5fa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-paper/95 backdrop-blur border-b border-hairline fixed top-0 left-0 right-0 z-50" }
const _hoisted_2 = { class: "container mx-auto flex justify-between items-center py-4 px-6 md:px-8" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#top",
  class: "font-serif-display text-xl text-ink tracking-tight"
}, " Juan Alonso Rodríguez ", -1))
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["aria-label"]

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderPortafolio',
  setup(__props) {

const links = [
  { href: '#about', label: 'Sobre Mí' },
  { href: '#experience', label: 'Experiencia' },
  { href: '#skills', label: 'Habilidades' },
  { href: '#backend', label: 'Back-end' },
  { href: '#frontend', label: 'Front-end' },
  { href: '#contact', label: 'Contacto' },
];

const isMenuOpen = ref(false);
const isDark = ref(document.documentElement.classList.contains('dark'));

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};
const closeMenu = () => {
  isMenuOpen.value = false;
};
const toggleTheme = () => {
  isDark.value = !isDark.value;
  document.documentElement.classList.toggle('dark', isDark.value);
  localStorage.setItem('theme', isDark.value ? 'dark' : 'light');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("nav", {
          class: _normalizeClass([
            'md:flex md:gap-6 md:items-center',
            {
              hidden: !isMenuOpen.value,
              'absolute top-full left-0 right-0 bg-paper border-b border-hairline p-6 space-y-3 md:space-y-0':
                isMenuOpen.value,
            },
            'md:relative md:border-0 md:p-0',
          ])
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (link) => {
            return _createElementVNode("a", {
              key: link.href,
              href: link.href,
              class: "nav-link",
              onClick: closeMenu
            }, _toDisplayString(link.label), 9, _hoisted_5)
          }), 64))
        ], 2),
        _createElementVNode("button", {
          class: "w-9 h-9 flex items-center justify-center border border-hairline rounded-sm text-subtle hover:text-ink hover:border-subtle transition-colors",
          "aria-label": isDark.value ? 'Cambiar a modo día' : 'Cambiar a modo noche',
          onClick: toggleTheme
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(isDark.value ? 'fas fa-sun' : 'fas fa-moon')
          }, null, 2)
        ], 8, _hoisted_6),
        _createElementVNode("button", {
          class: "w-9 h-9 flex items-center justify-center border border-hairline rounded-sm text-subtle hover:text-ink md:hidden",
          "aria-label": "Menú",
          onClick: toggleMenu
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(isMenuOpen.value ? 'fas fa-times' : 'fas fa-bars')
          }, null, 2)
        ])
      ])
    ])
  ]))
}
}

})